<template>
  <div class="sc-mt-bubble mt-2">
    <div class="flex-row-1 align-center">
      <div class="flex-row-1">
        <img
          alt="Category"
          :src="getImage()"
          class="sc-phone-item"
        >
        <div class="sc-phone-container">
          <span class="sc-phone-subtitle">{{ sub }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyTechPreviewItem',
  props: {
    sub: String,
    imageSrc: String,
  },
  methods: {
    getImage() {
      return require(`@shared/assets/img/partner-detail/${this.imageSrc}.svg`);
    },
  },
};
</script>

<style lang="scss">
.sc-mt-bubble {
  background-color: #F3F4F6;
  width: 100%;
  height: 52px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 10px;

  &:not(:first-child) {
    margin-top: 4px;
  }

  .sc-phone-item {
    height: 32px;
  }

  .sc-phone-container {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    margin-left: 8px;

    .sc-phone-title {
      font-size: 0.75rem;
      font-weight: bold;
      color: black;
    }

    .sc-phone-subtitle {
      font-size: 0.6rem;
      ;
      color: black;
    }
  }

  .sc-arrow-img {
    height: 7px;
  }
}
</style>
